import { Audience } from './audience';

export * from './site-pages';
export * from './pages';
export * from './audience';

export const TabIds = {
  PrivacyTools: 1,
  VisitorData: 2,
};

export enum TranslationKey {
  ConsentButton = 'accept.cookies.button',
  SettingButton = 'open.settings.button',
  PrivacyLink = 'view.privacy.policy',
  DeclineAllButton = 'decline.all.button',
  PrivacyInfo = 'policy.banner.text',
  PolicyUrl = 'policy.external.url',
  SaveButton = 'display.save.default',

  EssensialCategoryHeadline = 'advanced.category.essential.headline',
  EssensialCategoryParagraph = 'advanced.category.essential.paragraph',
  MarketingCategoryHeadline = 'advanced.category.marketing.headline',
  MarketingCategoryParagraph = 'advanced.category.marketing.paragraph',
  FunctionalCategoryHeadline = 'advanced.category.functional.headline',
  FunctionalCategoryParagraph = 'advanced.category.functional.paragraph',
  AnalyticsCategoryHeadline = 'advanced.category.analytics.headline',
  AnalyticsCategoryParagraph = 'advanced.category.analytics.paragraph',
}

export type TranslationsMap = {
  [TranslationKey.ConsentButton]: string;
  [TranslationKey.SettingButton]: string;
  [TranslationKey.PrivacyLink]: string;
  [TranslationKey.DeclineAllButton]: string;
  [TranslationKey.PrivacyInfo]: string;
  [TranslationKey.PolicyUrl]: string;
  [TranslationKey.SaveButton]: string;

  [TranslationKey.EssensialCategoryHeadline]: string;
  [TranslationKey.EssensialCategoryParagraph]: string;
  [TranslationKey.MarketingCategoryHeadline]: string;
  [TranslationKey.MarketingCategoryParagraph]: string;
  [TranslationKey.FunctionalCategoryHeadline]: string;
  [TranslationKey.FunctionalCategoryParagraph]: string;
  [TranslationKey.AnalyticsCategoryHeadline]: string;
  [TranslationKey.AnalyticsCategoryParagraph]: string;
};

export type TranslationObject = {
  languageKey: {
    languageCode: string;
    regionCode: string;
  };
  translations: TranslationsMap;
};

export enum Theme {
  light = 'light',
  dark = 'dark',
}

export type Timestamp = number;

export enum PrivacyPolicyType {
  PageOnSite = 'page-on-site',
  ExternalUrl = 'external-url',
}

export type DeclineAllConfig = {
  enabled: boolean;
  geo: string[];
};

export interface AppSettings {
  texts: TranslationsMap;
  appEnabled: boolean;
  expiryDate?: Timestamp;
  theme: Theme;
  cookiePolicyRequirementApproved: boolean;
  privacyPolicyType: PrivacyPolicyType;
  privacyPolicyPage: string;
  audience: Audience;
  declineAllConfig: DeclineAllConfig;
}

export interface ComponentSettings {
  settings: Partial<AppSettings>;
}

export enum SaveFlowStatus {
  None,
  ApproveMissingLink,
  ReviewRequirementsMissing,
  Saving,
  FailedToSave,
  SuccessfullySaved,
}

export interface SaveState {
  pendingChanges: boolean;
  status: SaveFlowStatus;
}
